import {AsyncPipe} from "@angular/common";
import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MatChipListbox, MatChipOption, MatChipRemove} from '@angular/material/chips';
import {MatIcon} from '@angular/material/icon';
import {Asset, AssetService} from '@app/asset';
import {Tag} from '@app/tag/models';
import {FilterQuery, TagInputComponent} from '@app/tag/tag-input/tag-input.component';
import {TagService} from '@app/tag/tag.service';
import {BehaviorSubject, Observable, of, switchMap} from "rxjs";
import {map} from "rxjs/operators";

@Component({
    selector: 'frog-tag-inspector',
    templateUrl: './tag-inspector.component.html',
    styleUrls: ['./tag-inspector.component.scss'],
    imports: [MatIcon, MatChipListbox, MatChipOption, MatChipRemove, TagInputComponent, AsyncPipe],
})
export class TagInspectorComponent implements OnInit, OnChanges {
    @Input() asset: Asset;

    public excludeCategories: string[];
    public tags$: Observable<Tag[]>;

    private tagIds$: BehaviorSubject<string[]>;

    constructor(
        private tagService: TagService,
        private assetService: AssetService,
    ) {
        this.excludeCategories = ['artist'];
    }

    ngOnInit(): void {
        this.tagIds$ = new BehaviorSubject<string[]>(this.asset.tag_ids);
        this.tags$ = this.tagIds$
            .pipe(
                switchMap(ids => {
                    if (!ids.length) {
                        return of([]);
                    }

                    return this.tagService.resolveGuids(ids);
                }),
                map(tags => tags.filter(t => this.excludeCategories.indexOf(t.category) === -1))
            );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['asset'] && !changes['asset'].firstChange) {
            this.tagIds$.next(this.asset.tag_ids);
        }
    }

    removeTag(tag: Tag) {
        this.tagIds$.next(this.tagIds$.value.filter(id => id !== tag.id));
        this.assetService.assignTags([this.asset.id], [], [tag.id]);
    }

    addTag(filterQuery: FilterQuery) {
        const parsedValue = filterQuery.value.replace(/"/g, '');
        this.tagService.resolveName(parsedValue).subscribe((tag) => {
            this.tagIds$.next([...this.tagIds$.value, tag.id]);
            this.assetService.assignTags([this.asset.id], [tag.id], []);
        });
    }
}
